import {createContext} from "react";

const DrawerContext = createContext({
    title: '',
    setTitle: () => {}
});

export default DrawerContext;